import { useLayoutMode } from '../hooks/useLayoutMode';
import { DesktopShell } from './DesktopShell';
import { MobileShell } from './MobileShell';

export function AppShell() {
  const { mode } = useLayoutMode();
  return mode === 'desktop' ? <DesktopShell /> : <MobileShell />;
}
